package com.advaita.cloud.drive.shared

import kotlinx.serialization.Serializable

/** A team of the caller. [lead] is true when the caller leads it. */
@Serializable
data class MyTeamDto(
    val teamId: String,
    val name: String,
    val lead: Boolean,
)

/**
 * CR-6.5 (D9): `GET /api/me/access`. [status] and [baseRole] are the caller's standing in DataHub
 * from the vault services view (null when that read failed). [orgAdmin] is the org-wide flag.
 * [consoleUrl] is set only for an org admin or a team lead, and only when the pod knows a safe
 * console URL (D13). [servicesStatus] and [teamsStatus] are [SourceStatus] values.
 */
@Serializable
data class MeAccessDto(
    val status: String? = null,
    val baseRole: String? = null,
    val orgAdmin: Boolean = false,
    val teams: List<MyTeamDto> = emptyList(),
    val consoleUrl: String? = null,
    val servicesStatus: String,
    val teamsStatus: String,
)
